/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
    CriteriaQualifierToJSONTyped,
} from './CriteriaQualifier';

/**
 * 
 * @export
 * @interface ScreenerSpecialCriteria
 */
export interface ScreenerSpecialCriteria {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    display_name: string;
    /**
     * 
     */
    description: string;
    /**
     * 
     */
    identifier: ScreenerSpecialCriteriaIdentifierEnum;
    /**
     * 
     */
    qualifier?: CriteriaQualifier;
    /**
     * 
     */
    enabled: boolean;
    /**
     * 
     */
    requires_payment?: boolean;
    /**
     * 
     */
    is_paid?: boolean;
}


/**
 * @export
 */
export const ScreenerSpecialCriteriaIdentifierEnum = {
    SexOffenderCheck: 'SEX_OFFENDER_CHECK',
    FollowupAppointments: 'FOLLOWUP_APPOINTMENTS',
} as const;
export type ScreenerSpecialCriteriaIdentifierEnum = typeof ScreenerSpecialCriteriaIdentifierEnum[keyof typeof ScreenerSpecialCriteriaIdentifierEnum];


/**
 * Check if a given object implements the ScreenerSpecialCriteria interface.
 */
export function instanceOfScreenerSpecialCriteria(value: object): value is ScreenerSpecialCriteria {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function ScreenerSpecialCriteriaFromJSON(json: any): ScreenerSpecialCriteria {
    return ScreenerSpecialCriteriaFromJSONTyped(json, false);
}

export function ScreenerSpecialCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerSpecialCriteria {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'display_name': json['display_name'],
        'description': json['description'],
        'identifier': json['identifier'],
        'qualifier': json['qualifier'] == null ? undefined : CriteriaQualifierFromJSON(json['qualifier']),
        'enabled': json['enabled'],
        'requires_payment': json['requires_payment'] == null ? undefined : json['requires_payment'],
        'is_paid': json['is_paid'] == null ? undefined : json['is_paid'],
    };
}

export function ScreenerSpecialCriteriaToJSON(json: any): ScreenerSpecialCriteria {
    return ScreenerSpecialCriteriaToJSONTyped(json, false);
}

export function ScreenerSpecialCriteriaToJSONTyped(value?: ScreenerSpecialCriteria | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'display_name': value['display_name'],
        'description': value['description'],
        'identifier': value['identifier'],
        'qualifier': CriteriaQualifierToJSON(value['qualifier']),
        'enabled': value['enabled'],
        'requires_payment': value['requires_payment'],
        'is_paid': value['is_paid'],
    };
}

